import React from 'react';

import { DockProps } from './index.types';
import { DockView } from './index.view';

export default function Dock(props: DockProps) {
  return <DockView {...props} />;
}
